import { Text } from 'tradera/components/atoms/text/text';
import { classNames } from 'tradera/utils/class-names';
import UserIcon from '@tradera/blueprint/theme/icons2/user.svg?jsx';
import styles from './profile.module.scss';

type ProfileProps = {
    isLoggedIn: boolean;
    facebookId: string | null;
    profilePicture: string | null;
    firstLetter?: string;
};

export const Profile = ({
    isLoggedIn,
    facebookId,
    profilePicture,
    firstLetter,
}: ProfileProps) => {
    if (isLoggedIn && profilePicture) {
        return (
            <img alt="Profile" width="21" height="21" src={profilePicture} />
        );
    }

    if (isLoggedIn && facebookId) {
        return (
            <img
                alt="Profile"
                width="21"
                height="21"
                src={`https://graph.facebook.com/v17.0/${facebookId}/picture?type=square&height=48&width=48`}
            />
        );
    }

    return (
        <>
            <UserIcon className="icon icon-md d-block d-lg-none" />

            <div
                className={classNames('d-none', styles.noImage, {
                    'd-lg-flex align-items-center justify-content-center':
                        isLoggedIn,
                })}>
                <Text
                    color="primary"
                    fontWeight="heavy"
                    font="hansen"
                    className="size-oslo text-uppercase">
                    {firstLetter}
                </Text>
            </div>
        </>
    );
};
